/** "13 Sept 2026, 12:13" — date and time, because two edits in one day are normal.
 *
 * Rendered in the VIEWER's timezone. The API sends an instant with an offset
 * (the graph columns are `timestamptz`), so `new Date` resolves it correctly
 * wherever the reader is and `toLocaleString` prints it in their zone.
 *
 * This used to read the parts out and rebuild them as a local Date, which threw
 * the offset away and showed every reader the SERVER's wall clock — seven hours
 * out for a UTC+7 reader against a UTC droplet. If a value ever arrives without
 * an offset again, that is the bug coming back, not something to patch here:
 * fix the column, because a naive stamp does not say which zone it is in and no
 * amount of frontend work can recover that.
 */
export function formatStamp(value) {
  if (!value) return "—";
  const at = new Date(value);
  if (Number.isNaN(at.getTime())) return "—";
  return at.toLocaleString(undefined, {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export default formatStamp;
